module.exports = __webpack_public_path__ + "static/media/bubble_10.c2ba7ea4.jpg";